import { toast } from "react-toastify";
import Results from "../Results";
import IcDuplicar from "../Svg/IcDuplicar";
import useFormat from "../../hooks/utils/useFormat";
import {
  METHOD_LABEL,
  ACCOUNT_TYPE_LABEL,
  ACCOUNT_OWNERSHIP_LABEL,
  PIX_KEY_TYPE_LABEL,
  formatPixKey,
  formatDocument,
} from "../../util/paymentMethods";
import style from "./style.module.scss";

/**
 * Dados de pagamento registrados (chave PIX / conta de destino), somente
 * leitura — os campos que o gestor digita no banco/app ganham botão de copiar.
 */
export default function PaymentDetails(props) {
  // aceita tanto o título (o combinado) quanto a parcela (o executado): as duas
  // guardam o mesmo conjunto de colunas payment_*
  const { payment, className } = props;
  const { formatDate } = useFormat();

  const copy = async (__label, __value) => {
    try {
      await navigator.clipboard.writeText(String(__value));
      toast.success(`${__label} copiado!`);
    } catch (__error) {
      toast.error("Não foi possível copiar. Selecione e copie manualmente.");
      console.log("__error", __error);
    }
  };

  // exibe formatado, mas copia o valor cru: é o que os bancos aceitam colar
  const copyable = (__label, __value, __rawValue) => (
    <button
      type="button"
      className={style.copy}
      onClick={() => copy(__label, __rawValue || __value)}
      title={`Copiar ${__label}`}
    >
      <span>{__value}</span>
      <IcDuplicar />
    </button>
  );

  const _rows = [];

  if (payment?.payment_pix_key) {
    const _pix_type = PIX_KEY_TYPE_LABEL[payment?.payment_pix_type];
    _rows.push({
      label: _pix_type ? `Chave PIX (${_pix_type})` : "Chave PIX",
      value: copyable(
        "Chave PIX",
        formatPixKey(payment.payment_pix_type, payment.payment_pix_key),
        payment.payment_pix_key,
      ),
      nowrap: true,
    });
    if (payment?.payment_pix_bank) _rows.push({ label: "Banco (PIX)", value: payment.payment_pix_bank });
    if (payment?.payment_pix_name) _rows.push({ label: "Titular (PIX)", value: payment.payment_pix_name });
  }

  if (payment?.payment_bank || payment?.payment_account) {
    if (payment?.payment_bank) _rows.push({ label: "Banco", value: payment.payment_bank });
    if (payment?.payment_agency)
      _rows.push({ label: "Agência", value: copyable("Agência", payment.payment_agency), nowrap: true });
    if (payment?.payment_account)
      _rows.push({ label: "Conta", value: copyable("Conta", payment.payment_account), nowrap: true });
    if (payment?.payment_account_type)
      _rows.push({
        label: "Tipo",
        value: ACCOUNT_TYPE_LABEL[payment.payment_account_type] || payment.payment_account_type,
      });
    if (payment?.payment_account_ownership)
      _rows.push({
        label: "Titularidade",
        value: ACCOUNT_OWNERSHIP_LABEL[payment.payment_account_ownership] || payment.payment_account_ownership,
      });
    if (payment?.payment_account_document)
      _rows.push({
        label: payment?.payment_account_ownership === "cpf" ? "CPF" : "CNPJ",
        value: copyable(
          "Documento",
          formatDocument(payment.payment_account_ownership, payment.payment_account_document),
          payment.payment_account_document,
        ),
        nowrap: true,
      });
  }

  if (!_rows.length) {
    return (
      <div className={className}>
        <p className="small-label mb-0">
          Este título não tem dados de pagamento registrados. Complete as informações de pagamento no cadastro do
          fornecedor e use "Atualizar com dados atuais do fornecedor".
        </p>
      </div>
    );
  }

  return (
    <div className={className}>
      <Results
        rows={[
          {
            label: <b>Método</b>,
            value: <b>{METHOD_LABEL[payment?.method_payment] || payment?.method_payment || "-"}</b>,
            type: "dark",
          },
          ..._rows,
        ]}
      />
      {!!payment?.payment_snapshot_at && (
        <span className="small-label">Dados registrados em {formatDate(payment.payment_snapshot_at, 5)}</span>
      )}
    </div>
  );
}
